import { useTranslation } from 'react-i18next';



export interface PhotoItemObject {
	image: any,
	text?: string,
	name?: string,
}



interface PhotoItemProps {
	item: PhotoItemObject,
}


const PhotoItem = (props: PhotoItemProps) => {
	const { image, text, name } = props.item;
	const { t } = useTranslation('web');

	return (
		<div className="photo-item">
			
			<img src={image} alt='gallery-photo' draggable={false} />

			{text && text.length > 0 &&
				<div className='photo-item-text'>
					
					<p className='customer-text'>{t(`pages.gallery.galleryItems.${text}`)}</p>
					
					{name && name.length > 0 &&
						<p className='customer-name'>{t(`pages.gallery.galleryItems.${name}`)}</p>}
				
				</div>}
		</div>
	);
};

export default PhotoItem;